import * as React from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';

import { createBrowserHistory } from 'history';
const history = createBrowserHistory();

export interface FormProps {
  submitFunction: Function;
}
class Form extends React.Component<FormProps> {

  public state: any;

  public constructor(props: any) {

    super(props);

    this.state = {
      search: '',
      location: '',
      radius: 99
    };

    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
  }

  public componentDidMount() {

    const search = sessionStorage.getItem('search');
    const location = sessionStorage.getItem('location');
    const radius = sessionStorage.getItem('radius');

    if (search === null) {

      return;
    }

    this.setState({
      search: search,
      location: location,
      radius: radius
    });

    this.props.submitFunction(this.state.search, this.state.location, this.state.radius);
  }

  public handleChangeLocation(event: any) {
    this.setState({ location: event.target.value });
  }

  public handleChangeSearch(event: any) {
    this.setState({ search: event.target.value });
  }

  public submitForm() {

    console.log(history.location);

    var page = document.location.pathname;
    window.ga('set', 'page', page);
    window.ga('send', 'pageview');

    sessionStorage.setItem('search', this.state.search);
    sessionStorage.setItem('location', this.state.location);
    sessionStorage.setItem('radius', this.state.radius);

    history.push(`/jobs?search=${this.state.search}&location=${this.state.location}&radius=${this.state.radius}`);
    this.props.submitFunction(this.state.search, this.state.location, 1, this.state.radius);
  }

  public render() {
    return (
      <div className="form-wrapper">
        <div className="form-element">
          <label>Job</label>
          <input
            type="text"
            value={this.state.search}
            onChange={this.handleChangeSearch}
            placeholder="Suchbegriff"
          />
        </div>
        <div className="form-element">
          <label>Ort</label>
          <input
            type="text"
            value={this.state.location}
            onChange={this.handleChangeLocation}
            placeholder="Ort / Plz / Region"
          />
          <br />
          <div>
            <div className="label-small">Umkreissuche</div>
            <Slider
              value={this.state.radius}
              min={0}
              max={250}
              onChange={this.handleChange}
            />
          </div>
        </div>

        <div className="form-element button">
          <label>&nbsp;</label>
          <button onClick={() => { this.submitForm(); }}>Suchen</button>
        </div>
      </div>
    );
  }

  private handleChange = (value) => {
    
    this.setState({
      radius: value
    });
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/Form.tsx